"use client"

import { Routes } from "@/lib/routes"
import { usePathname } from "next/navigation"

const GLOBAL_DISCLAIMER =
   "The American Restaurant Association is an independent global organization representing restaurant owners and focused on improving business outcomes. It is not affiliated with, sponsored by, or endorsed by any other national, state, provincial, or local restaurant association."

const LEGAL_DISCLAIMER =
   "The American Restaurant Association is an independent global organization representing restaurant owners and focused on improving business outcomes. It is not affiliated with, sponsored by, or endorsed by any other national, state, provincial, or local restaurant association."

const LEGAL_PATHS = [
   Routes.client.termsAndConditions.getPath(),
   Routes.client.privacyPolicy.getPath(),
   Routes.client.disclosurePolicy.getPath(),
   Routes.client.reviewGuidelines.getPath(),
   Routes.client.ethics.getPath(),
   Routes.client.editorialStandards.getPath(),
   Routes.client.codeOfEthics.getPath(),
   Routes.client.membershipTerms.getPath(),
]

function getDisclaimer(pathname: string | null) {
   if (!pathname) return null

   const normalizedPathname = pathname.endsWith("/") ? pathname : `${pathname}/`

   if (LEGAL_PATHS.includes(normalizedPathname)) return LEGAL_DISCLAIMER

   return GLOBAL_DISCLAIMER
}

export function FooterDisclaimer() {
   const pathname = usePathname()
   const disclaimer = getDisclaimer(pathname)

   if (!disclaimer) {
      return (
         <div className="mt-4 border-t border-gray-800 pt-8 text-center text-[14px] text-[#BABCBF]">
            <p>&copy; {new Date().getFullYear()} American Restaurant Association. All rights reserved.</p>
         </div>
      )
   }

   return (
      <div className="mt-4 flex flex-col items-center justify-between gap-3 border-t border-gray-800 pt-8 text-center font-satoshi text-[14px] text-[#BABCBF] md:flex-row md:gap-0">
         <p className="max-w-[80ch] text-center md:text-start">{disclaimer}</p>
         <p>&copy; {new Date().getFullYear()} American Restaurant Association. All rights reserved.</p>
      </div>
   )
}
